module.exports = __webpack_public_path__ + "static/media/upload.92281108.svg";